import React from "react";
import { Modal, Input, message, Button } from "antd";
import { post } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
import { PostUploadAttachment, CommonPostConfirmPay } from "$DATA/wallet";
import { getE2BBValue } from "$ACTIONS/helper";
class UploadFile extends React.Component {
    static defaultProps = {
        children: null,
    };
    constructor(props) {
        super(props);
        this.state = {
            fileName: "",
            uploadSizeFlag: false,
        };
    }
    messageInfo = (html, loading) => {
        function appendDom() {
            let boxWrap = document.createElement("div");
            let infoBox = document.createElement("p");
            boxWrap.setAttribute("id", "t_alert_mask");
            boxWrap.setAttribute("class", "t-alert-mask");
            infoBox.innerHTML = html;
            boxWrap.appendChild(infoBox);
            document.body.appendChild(boxWrap);
            return boxWrap;
        }
        if (typeof loading === "boolean") {
            if (loading === true) {
                appendDom();
            } else {
                let boxWrap = document.getElementById("t_alert_mask");
                boxWrap && boxWrap.remove();
            }
        } else {
            let boxWrap = appendDom();
            // 当组件被卸载掉后，如果还能查询到当前元素则在指定时间后需要移除
            setTimeout(() => {
                boxWrap && boxWrap.remove();
            }, 3000);
        }
    };

    //上传文件
    uploadFile = (e) => {
        let self = this;
        let fileName = e.target.files[0].name;
        var reader = new FileReader();
        reader.onload = (function (file) {
            return function (e) {
                let fileBytes = this.result.split(",")[1];
                self.setState(
                    {
                        file: file,
                        fileName,
                        fileBytes,
                        uploadSizeFlag: !(
                            file.size <= 4194304 &&
                            ["png", "jpg", "jpeg"].includes(
                                fileName.split(".")[
                                    fileName.split(".").length - 1
                                ]
                            )
                        ),
                    },
                    () => {}
                );
            };
        })(e.target.files[0]);
        reader.readAsDataURL(e.target.files[0]);
    };

    UploadAttachment = () => {
        this.setState({
            filestatus: 0,
        });
        this.messageInfo(
            "<div><img src='/cn/img/icons/loading.gif' width='35px' style='margin-bottom:5px'><br>文档上传中<br>请稍等...</div>",
            true
        );
        const memberInfo = JSON.parse(localStorage.getItem("memberInfo"));
        PostUploadAttachment(
            {
                DepositID: this.props.transactionId,
                PaymentMethod: this.props.paymentType,
                FileName: this.state.fileName,
                byteAttachment: this.state.fileBytes,
                RequestedBy: memberInfo ? memberInfo.memberCode : "",
                blackBoxValue: getE2BBValue(),
                e2BlackBoxValue: getE2BBValue(),
            },
            (res) => {
                if (res.isSuccess == true) {
                    this.setState({
                        filestatus: 1,
                        filesuccess: true,
                        visible: false,
                    });

                    const afterUploadedFunc1 = () => {
                    this.messageInfo("​", false);
                    }
                    const afterUploadedFunc2 = () => {
                    this.props.setFileName(this.state.fileName);
                    message.success("存款凭证已上传", 5);
                    }
                    const afterUploadedFunc = () => {
                        afterUploadedFunc1();
                        afterUploadedFunc2();
                    }

                    const isAutoPopupShow = this.props.isAutoShow;
                    const isDepositReceiptRequired = this.props.isDepositReceiptRequired;
                    const needPostConfirm = isAutoPopupShow && isDepositReceiptRequired;// so far, only for ODP and some PPB
                    if (!needPostConfirm) {
                        afterUploadedFunc();
                    } else {
                        // cxpc-684
                        let postOtherInfo = {
                            Id: this.props.transactionId,
                            CurrencyCode: "CNY",
                            hasQR: true,
                            dynamicObject: {
                                depositingBankAcctNum: '',
                                offlineDepositDate: '',
                                fileName: '',
                                fileByte: ''
                            }
                        };
                        CommonPostConfirmPay(postOtherInfo, (res) => { /* cxpc-684 */
                            let status = res && res.isSuccess;
                            if (status) {
                                afterUploadedFunc();
                            } else {
                                afterUploadedFunc1();
                                let _ = res?.errors?.length ? res.errors[0] : {};
                                let s = _.message || '';
                                let c = _.errorCode;
                                if (c) {
                                    s += ('['+c+']');
                                }
                                message.error(s);
                            }
                        }, {IS_BFFSC_HOST:true});
                    }

                } else {
                    this.setState({
                        filestatus: 2,
                    });
                    this.messageInfo("​", false);
                }
            }
        );
    };
    render() {
        const isAutoPopupShow = this.props.isAutoShow;
        const isDepositReceiptRequired = this.props.isDepositReceiptRequired;
        const visibleValue = this.state.visible || (isAutoPopupShow && !this.state.filesuccess);

        const _ErrorText1 = this.state.uploadSizeFlag;
        const _ErrorText2 = this.state.filestatus == 2;
        const _noErrorText = !_ErrorText1 && !_ErrorText2;
        return this.props.children || isAutoPopupShow ? (
            <React.Fragment>
                {this.props.children && <div
                    style={
                        this.props.inline === true
                            ? { display: "inline-block" }
                            : { display: "block", width: "100%" }
                    }
                    onClick={() => {
                        this.setState({
                            visible: true,
                        });
                    }}
                >
                    {this.props.children}
                </div>}
                <Modal
                    closable={false}
                    width={isAutoPopupShow ? 400 : undefined}
                    className={'modal-pubilc UploadFileModal' + (isAutoPopupShow ? ' upload-file-modal-auto-popup-show' : '')}
                    title="上传存款凭证"
                    visible={visibleValue}
                    footer={null}
                    maskClosable={false}
                    centereds={true}
                    key={visibleValue}
                    // onCancel={this.props.onClose}
                >
                    <div className="btn-content-set">
                        {isAutoPopupShow ? <>
                            <div className="modal-prompt-info" style={{marginBottom:0}}>
                                请上传存款凭证，否则将无法完成这笔存款。</div>
                            <div style={{fontWeight:'bold',fontSize:16,textAlign:'center',marginTop:16}}>
                                上传存款凭证以完成存款交易</div>
                        </> :
                        <p>
                            请上传存款凭证，仅接受 jpg 及 png
                            档案，且档案大小不得超过4MB。
                        </p>
                        }
                        {isAutoPopupShow ?
                            <div style={{fontWeight:'bold',fontSize:14,display:'inline-block',marginTop:20}}>
                                <span style={{float:'right',backgroundColor: '#fff5bf',borderRadius:8,color:'#83630b',fontSize: 12,padding:4,fontWeight:'normal',margin:'-2px 0 0 8px'}}>
                                    {isDepositReceiptRequired ? '必填' : '推荐使用'}
                                </span>
                            存款凭证</div>
                            :
                        <label>存款凭证</label>
                        }
                        <div className="btn-content-file " id="updataset">
                            <span className="imgname">
                                {this.state.fileName}
                            </span>

                            <Button size="large" type="primary">
                                选择文档
                                <input
                                    value=""
                                    type="file"
                                    accept=".jpg,.jpeg,.png"
                                    className="Modal_file_btn"
                                    onChange={(e) => {
                                        this.uploadFile(e);
                                    }}
                                />
                            </Button>
                        </div>
                        {isAutoPopupShow && _noErrorText && (
                            <span style={{color:'#666'}}>仅接受 jpg 及 png 档案，且档案大小不得超过 4MB</span>
                        )}
                        {_ErrorText1 && (
                            <span className="red">
                                仅接受 jpg 及 png 档案，且档案大小不得超过4MB。
                            </span>
                        )}
                        {_ErrorText2 && (
                            <span className="red">
                                上传失败由于未知的错误，请稍后再试
                            </span>
                        )}
                        <div className="btn-content" style={isAutoPopupShow ? {marginTop:14} : {}}>
                            {isAutoPopupShow ? (isDepositReceiptRequired ? null : <Button
                                className="left"
                                onClick={() => {
                                let _modal = Modal.confirm({
                                    className: "blueHeaderModal",
                                    wrapClassName: "blueHeaderModal",
                                    title: "存款凭证尚未提交",
                                    icon: null,
                                    centered: true,
                                    okText: "继续上传",
                                    cancelText: "离开",
                                    content: (
                                        <div style={{ textAlign: "center" }}>
                                            您上传的存款凭证尚未提交，如离开将会需要重新操作
                                        </div>
                                    ),
                                    onCancel: () => {
                                    this.setState({
                                        visible: false,
                                        fileName: "",
                                        filestatus: "3",
                                        uploadSizeFlag: false,
                                    });
                                    this.props.setFileName('', true);
                                    },
                                    onOk: () => {
                                        _modal.destroy();
                                    } // end of onOk
                                }); // end of _modal
                                }}
                                size="large"
                                type="primary"
                                ghost
                                block
                            >
                                跳过
                            </Button>) :
                            <Button
                                className="left"
                                onClick={() => {
                                    this.setState({
                                        visible: false,
                                        fileName: "",
                                        filestatus: "3",
                                        uploadSizeFlag: false,
                                    });
                                }}
                                size="large"
                                type="primary"
                                ghost
                                block
                            >
                                关闭
                            </Button>}
                            {this.state.fileName &&
                                this.state.fileName !== "" &&
                                !this.state.uploadSizeFlag && (
                                    <Button
                                        onClick={() => {
                                            this.UploadAttachment();
                                        }}
                                        size="large"
                                        type="primary"
                                        block
                                    >
                                        {isAutoPopupShow ? '提交' : '上传存款凭证'}
                                    </Button>
                                )}
                            {(this.state.fileName == "" ||
                                this.state.uploadSizeFlag) && (
                                <Button
                                    className="filebtn"
                                    size="large"
                                    type="primary"
                                    block
                                    disabled
                                >
                                    {isAutoPopupShow ? '提交' : '上传存款凭证'}
                                </Button>
                            )}
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        ) : null;
    }
}

export default UploadFile;
